export const waitAndScrollToEement = async (
  selector: string,
  timeout: number = 5_000,
  timeoutCallback?: () => void,
) => {
  return new Promise<void>((resolve) => {
    const observer = new MutationObserver((_, obs) => {
      const element = document.querySelector(selector);

      if (element) {
        element.scrollIntoView();
        obs.disconnect();
        resolve();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    setTimeout(() => {
      observer.disconnect();
      resolve();
      timeoutCallback && timeoutCallback();
    }, timeout);
  });
};
